import React from 'react';
import { Link } from 'react-router';

export default function BrandLogo({ logo, isScribeLogoEnabled }) {
  const { image, altText, url } = logo;

  return (
    <div className="hd-header__logo hd-header__logo--prominent">
      <Link
        to={url}
        title="Home"
        className={`hd-header__logoLink ${isScribeLogoEnabled ? 'hd-header__logoLink--withScribeLogo' : ''}`}
      >
        <img
          src={image}
          alt={altText}
          className="hd-header__logoImg"
        />
      </Link>
    </div>
  );
}
